import React, { useCallback, useEffect, useState } from 'react';
import { Preloader } from '@common-fe/common-fe';
import _ from 'lodash';

import { RiskControlOptions } from '@/common/constants';
import ROUTES from '@/common/routes';
import { PreventLeaveModal } from '@/modules/core/components';
import { useHistory } from '@/modules/core/hooks';
import { useMyEnrollments } from '@/modules/transaction';

import { useFundingAmountStore } from '../BuySell/stores/useFundingAmount.store';
import {  useInvestorById } from '../hooks';
import PortfolioAllocation from '../StartInvesting/PortfolioAllocation';

import { ManagedWrapper } from '.';
interface Props {
  accountId: string;
  isSwitchMode?: boolean;
  isEmptyPortfolioMode?: boolean;
}
const ManagedSwitchAllocation: React.FC<Props> = ({ accountId, isSwitchMode, isEmptyPortfolioMode}) => {
  const [isPreventLeave, setPreventLeave] = useState(false);

  const { currentMyAccount, isLoading } = useMyEnrollments(accountId);
  const { data: investor } = useInvestorById({ 
    isSwitchMode: false,
  });
  const [proposedToleranceModel, setProposedToleranceModel] = useState<RiskControlOptions>();
  const { values } = useFundingAmountStore();
  useEffect(() => {
    const model = investor?.proposedToleranceModel as string;
    if(proposedToleranceModel !== model && model) {
      setProposedToleranceModel(model as RiskControlOptions);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [investor?.proposedToleranceModel, investor.riskTolerance]);
  const [investmentAmount, setInvestmentAmount] = useState(0);
  const history = useHistory();
  const handleBack = useCallback(() => {
    if(isEmptyPortfolioMode) {
      history.push(ROUTES.MANAGED_SWITCH_EMPTY_FUNDING_AMOUNT(accountId)); 
    } else {
      history.goBack();
    }
    
  }, [accountId, history, isEmptyPortfolioMode]);
  const handleNext= useCallback(() => {
    setPreventLeave(false);
    history.push(`${ROUTES.INVESTMENTS}?id=${accountId}`);
  }, [accountId, history]);
  useEffect(() => {
    if (values.fundingAmount) {
      setInvestmentAmount(_.toNumber(values.fundingAmount || 0));
    } else if(investor?.balance && isSwitchMode && !isEmptyPortfolioMode) {
      setInvestmentAmount(_.toNumber(investor?.balance|| 0));
    } 
    if (investor?.proposedToleranceModel) {
      setProposedToleranceModel(investor?.proposedToleranceModel);
    }
  }, [investor, isEmptyPortfolioMode, isSwitchMode, values]);
  if(!investor?.investorId) {
    return null;
  }
  if(isLoading || !proposedToleranceModel) {
    return (
      <Preloader />
    );
  }
  return (
    <ManagedWrapper isSwitchMode={isSwitchMode} isEmptyPortfolioMode={isEmptyPortfolioMode} currentStep={isEmptyPortfolioMode ? 3 : 2}>
      <PreventLeaveModal isPrevent={isPreventLeave} />
      
      <PortfolioAllocation
        onBack={handleBack}
        handleGoDashboard={handleNext}
        isEmptyPortfolioMode={isEmptyPortfolioMode}
        isSwitchMode
        step={isEmptyPortfolioMode ? 3 : 2}
        stepLength={isEmptyPortfolioMode ? 3: 2}
        currentMyAccount={currentMyAccount}
        recommendedRisk={proposedToleranceModel}
        investmentAmount={investmentAmount}
        setInvestmentAmount={setInvestmentAmount}
        investorId={`${investor.investorId || ''}`} 
      />
   
    </ManagedWrapper>
  );
};
export default ManagedSwitchAllocation;